/* Yasme — scroll reveal (IntersectionObserver)
   Adds .is-visible to elements/containers with .yasme-reveal or
   .yasme-reveal-group when they scroll into view. Init runs once. */
(function () {
  if (window.__yasmeRevealInit) return;
  window.__yasmeRevealInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(el) { el.classList.add('is-visible'); }

  function init() {
    var els = document.querySelectorAll('.yasme-reveal, .yasme-reveal-group');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(reveal);
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          reveal(entry.target);
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) {
      if (!el.classList.contains('is-visible')) io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-scan when a section is (re)loaded in the Theme Editor.
  document.addEventListener('shopify:section:load', init);
})();
